module.exports = __webpack_public_path__ + "static/img/icons-arrow-down.fcc32399.svg";